<template>
  <div class="wrapper-import">
    <!-- Input Upload File -->
    <section class="mb-4">
      <div class="row">
        <div class="col-12">
          <!-- <section-title
            :title="$t('message.chosefilexlsx')"
            fontweight="bold"
          /> -->
          <div class="row mb-2">
            <div class="col-12 mb-2">
              <b>
                {{ $t('message.autopickcolumn') }}
              </b>
            </div>
            <div class="col-12">
              <div style="display: flex;gap: 20px;">
                <BaseRadioRich
                  v-model="autoPickColumn"
                  :val="1"
                  :label="$t('message.yes')"
                />
                <BaseRadioRich
                  v-model="autoPickColumn"
                  :val="0"
                  :label="$t('message.no')"
                />
              </div>
            </div>
          </div>
          <div class="file has-name is-fullwidth">
            <label class="file-label">
              <input
                ref="file"
                class="file-input"
                type="file"
                @change="handleFileUpload"
              >
              <span class="file-cta">
                <span class="file-icon">
                  <i class="fas fa-upload"/>
                </span>
                <span class="file-label">
                  {{ $t('message.choosefile') }}
                </span>
              </span>
              <span class="file-name">
                <span class="text-grey">
                  {{ inputFileHelperText }}
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </section>

    <template
      v-if="isUploadFailed"
    >
      <section>
        <div class="row">
          <div class="col-12">
            <span class="text-danger">
              {{ $t('message.invalidimporttemplate') }}
            </span>
          </div>
        </div>
      </section>
    </template>

    <template
      v-else
    >
      <!-- How to Import -->
      <section class="mb-2">
        <div class="row">
          <div class="col-12">
            <p class="mb-1">
              <b>{{ $t('message.importproductswith3steps') }}</b>
            </p>
            <p class="m-0">
              {{ $t('message.importproductstep1') }}
            </p>
            <p class="m-0">
              {{ $t('message.importproductstep2') }}
            </p>
            <p class="m-0">{{ $t('message.importproductstep3') }}</p>
          </div>
        </div>
      </section>

      <!-- Download Template -->
      <section class="mb-2">
        <div class="row">
          <div class="col-12">
            <p class="mb-1">
              <b>{{ $t('message.downloadexampleexcelfile') }}</b>
            </p>
            <p class="m-0">
              <a
                :href="templateLink.source"
                download
              >
                {{ templateLink.name }}
              </a>
            </p>
          </div>
        </div>
      </section>

      <!-- Note -->
      <section>
        <div class="row">
          <div class="col-12">
            <p class="mb-1">
              <b>{{ $t('message.note') }}</b>
            </p>
            <p class="m-0">
              {{ $t('message.noteimportexcelfile') }}
            </p>
          </div>
        </div>
      </section>
    </template>

  </div>
</template>

<script>
export default {
  props: {
    isUploadFailed: {
      type: Boolean,
      default: false,
    },
    uploadedFileName: {
      type: String,
      default: null,
    },
    templateLink: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      autoPickColumn: 0,
    }
  },

  computed: {
    isUploaded() {
      return !!this.uploadedFileName
    },
    inputFileHelperText() {
      if (this.isUploaded) {
        return this.uploadedFileName
      }
      return this.$t('message.nofilechosen')
    },
  },

  watch: {
    autoPickColumn: {
      handler: function() {
        this.$emit('update:autoPickColumn', !!this.autoPickColumn)
      },
      immediate: true,
    },
  },

  methods: {
    handleFileUpload(event) {
      this.$emit('onUpload', event)
    },
  },
}
</script>

<style scoped>
.file-cta:focus,
  .file-name:focus,
  .is-focused.file-cta,
  .is-focused.file-name,
  .file-cta:active,
  .file-name:active,
  .is-active.file-cta,
  .is-active.file-name {
    outline: none;
  }
  .file-name[disabled],
  fieldset[disabled] .file-cta,
  fieldset[disabled] .file-name {
    cursor: not-allowed;
  }

.file {
  align-items: stretch;
  display: flex;
  justify-content: flex-start;
  position: relative;
}

.file.is-white .file-cta {
  background-color: white;
  border-color: transparent;
  color: #0a0a0a;
}

.file.is-white:hover .file-cta, .file.is-white.is-hovered .file-cta {
  background-color: #f9f9f9;
  border-color: transparent;
  color: #0a0a0a;
}

.file.is-white:focus .file-cta, .file.is-white.is-focused .file-cta {
  border-color: transparent;
  box-shadow: 0 0 0.5em rgba(255, 255, 255, 0.25);
  color: #0a0a0a;
}

.file.is-white:active .file-cta, .file.is-white.is-active .file-cta {
  background-color: #f2f2f2;
  border-color: transparent;
  color: #0a0a0a;
}

.file.is-black .file-cta {
  background-color: #0a0a0a;
  border-color: transparent;
  color: white;
}

.file.is-black:hover .file-cta, .file.is-black.is-hovered .file-cta {
  background-color: #040404;
  border-color: transparent;
  color: white;
}

.file.is-black:focus .file-cta, .file.is-black.is-focused .file-cta {
  border-color: transparent;
  box-shadow: 0 0 0.5em rgba(10, 10, 10, 0.25);
  color: white;
}

.file.is-black:active .file-cta, .file.is-black.is-active .file-cta {
  background-color: black;
  border-color: transparent;
  color: white;
}

.file.is-light .file-cta {
  background-color: whitesmoke;
  border-color: transparent;
  color: #363636;
}

.file.is-light:hover .file-cta, .file.is-light.is-hovered .file-cta {
  background-color: #eeeeee;
  border-color: transparent;
  color: #363636;
}

.file.is-light:focus .file-cta, .file.is-light.is-focused .file-cta {
  border-color: transparent;
  box-shadow: 0 0 0.5em rgba(245, 245, 245, 0.25);
  color: #363636;
}

.file.is-light:active .file-cta, .file.is-light.is-active .file-cta {
  background-color: #e8e8e8;
  border-color: transparent;
  color: #363636;
}

.file.is-dark .file-cta {
  background-color: #363636;
  border-color: transparent;
  color: whitesmoke;
}

.file.is-dark:hover .file-cta, .file.is-dark.is-hovered .file-cta {
  background-color: #2f2f2f;
  border-color: transparent;
  color: whitesmoke;
}

.file.is-dark:focus .file-cta, .file.is-dark.is-focused .file-cta {
  border-color: transparent;
  box-shadow: 0 0 0.5em rgba(54, 54, 54, 0.25);
  color: whitesmoke;
}

.file.is-dark:active .file-cta, .file.is-dark.is-active .file-cta {
  background-color: #292929;
  border-color: transparent;
  color: whitesmoke;
}

.file.is-primary .file-cta {
  background-color: #00d1b2;
  border-color: transparent;
  color: #fff;
}

.file.is-primary:hover .file-cta, .file.is-primary.is-hovered .file-cta {
  background-color: #00c4a7;
  border-color: transparent;
  color: #fff;
}

.file.is-primary:focus .file-cta, .file.is-primary.is-focused .file-cta {
  border-color: transparent;
  box-shadow: 0 0 0.5em rgba(0, 209, 178, 0.25);
  color: #fff;
}

.file.is-primary:active .file-cta, .file.is-primary.is-active .file-cta {
  background-color: #00b89c;
  border-color: transparent;
  color: #fff;
}

.file.is-link .file-cta {
  background-color: #3273dc;
  border-color: transparent;
  color: #fff;
}

.file.is-link:hover .file-cta, .file.is-link.is-hovered .file-cta {
  background-color: #276cda;
  border-color: transparent;
  color: #fff;
}

.file.is-link:focus .file-cta, .file.is-link.is-focused .file-cta {
  border-color: transparent;
  box-shadow: 0 0 0.5em rgba(50, 115, 220, 0.25);
  color: #fff;
}

.file.is-link:active .file-cta, .file.is-link.is-active .file-cta {
  background-color: #2366d1;
  border-color: transparent;
  color: #fff;
}

.file.is-info .file-cta {
  background-color: #209cee;
  border-color: transparent;
  color: #fff;
}

.file.is-info:hover .file-cta, .file.is-info.is-hovered .file-cta {
  background-color: #1496ed;
  border-color: transparent;
  color: #fff;
}

.file.is-info:focus .file-cta, .file.is-info.is-focused .file-cta {
  border-color: transparent;
  box-shadow: 0 0 0.5em rgba(32, 156, 238, 0.25);
  color: #fff;
}

.file.is-info:active .file-cta, .file.is-info.is-active .file-cta {
  background-color: #118fe4;
  border-color: transparent;
  color: #fff;
}

.file.is-success .file-cta {
  background-color: #23d160;
  border-color: transparent;
  color: #fff;
}

.file.is-success:hover .file-cta, .file.is-success.is-hovered .file-cta {
  background-color: #22c65b;
  border-color: transparent;
  color: #fff;
}

.file.is-success:focus .file-cta, .file.is-success.is-focused .file-cta {
  border-color: transparent;
  box-shadow: 0 0 0.5em rgba(35, 209, 96, 0.25);
  color: #fff;
}

.file.is-success:active .file-cta, .file.is-success.is-active .file-cta {
  background-color: #20bc56;
  border-color: transparent;
  color: #fff;
}

.file.is-warning .file-cta {
  background-color: #ffdd57;
  border-color: transparent;
  color: rgba(0, 0, 0, 0.7);
}

.file.is-warning:hover .file-cta, .file.is-warning.is-hovered .file-cta {
  background-color: #ffdb4a;
  border-color: transparent;
  color: rgba(0, 0, 0, 0.7);
}

.file.is-warning:focus .file-cta, .file.is-warning.is-focused .file-cta {
  border-color: transparent;
  box-shadow: 0 0 0.5em rgba(255, 221, 87, 0.25);
  color: rgba(0, 0, 0, 0.7);
}

.file.is-warning:active .file-cta, .file.is-warning.is-active .file-cta {
  background-color: #ffd83d;
  border-color: transparent;
  color: rgba(0, 0, 0, 0.7);
}

.file.is-danger .file-cta {
  background-color: #ff3860;
  border-color: transparent;
  color: #fff;
}

.file.is-danger:hover .file-cta, .file.is-danger.is-hovered .file-cta {
  background-color: #ff2b56;
  border-color: transparent;
  color: #fff;
}

.file.is-danger:focus .file-cta, .file.is-danger.is-focused .file-cta {
  border-color: transparent;
  box-shadow: 0 0 0.5em rgba(255, 56, 96, 0.25);
  color: #fff;
}

.file.is-danger:active .file-cta, .file.is-danger.is-active .file-cta {
  background-color: #ff1f4b;
  border-color: transparent;
  color: #fff;
}

.file.is-small {
  font-size: 0.75rem;
}

.file.is-medium {
  font-size: 1.25rem;
}

.file.is-medium .file-icon .fa {
  font-size: 21px;
}

.file.is-large {
  font-size: 1.5rem;
}

.file.is-large .file-icon .fa {
  font-size: 28px;
}

.file.has-name .file-cta {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.file.has-name .file-name {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.file.has-name.is-empty .file-cta {
  border-radius: 4px;
}

.file.has-name.is-empty .file-name {
  display: none;
}

.file.is-boxed .file-label {
  flex-direction: column;
}

.file.is-boxed .file-cta {
  flex-direction: column;
  height: auto;
  padding: 1em 3em;
}

.file.is-boxed .file-name {
  border-width: 0 1px 1px;
}

.file.is-boxed .file-icon {
  height: 1.5em;
  width: 1.5em;
}

.file.is-boxed .file-icon .fa {
  font-size: 21px;
}

.file.is-boxed.is-small .file-icon .fa {
  font-size: 14px;
}

.file.is-boxed.is-medium .file-icon .fa {
  font-size: 28px;
}

.file.is-boxed.is-large .file-icon .fa {
  font-size: 35px;
}

.file.is-boxed.has-name .file-cta {
  border-radius: 4px 4px 0 0;
}

.file.is-boxed.has-name .file-name {
  border-radius: 0 0 4px 4px;
  border-width: 0 1px 1px;
}

.file.is-centered {
  justify-content: center;
}

.file.is-fullwidth .file-label {
  width: 100%;
}

.file.is-fullwidth .file-name {
  flex-grow: 1;
  max-width: none;
}

.file.is-right {
  justify-content: flex-end;
}

.file.is-right .file-cta {
  border-radius: 0 4px 4px 0;
}

.file.is-right .file-name {
  border-radius: 4px 0 0 4px;
  border-width: 1px 0 1px 1px;
  order: -1;
}

.file-label {
  align-items: stretch;
  display: flex;
  cursor: pointer;
  justify-content: flex-start;
  overflow: hidden;
  position: relative;
}

.file-label:hover .file-cta {
  background-color: #eeeeee;
  color: #363636;
}

.file-label:hover .file-name {
  border-color: #d5d5d5;
}

.file-label:active .file-cta {
  background-color: #e8e8e8;
  color: #363636;
}

.file-label:active .file-name {
  border-color: #cfcfcf;
}

.file-input {
  height: 100%;
  left: 0;
  opacity: 0;
  outline: none;
  position: absolute;
  top: 0;
  width: 100%;
}

.file-cta,
.file-name {
  border-color: #dbdbdb;
  border-radius: 4px;
  font-size: 1em;
  padding-left: 1em;
  padding-right: 1em;
  white-space: nowrap;
}

.file-cta {
  background-color: whitesmoke;
  color: #4a4a4a;
}

.file-name {
  border-color: #dbdbdb;
  border-style: solid;
  border-width: 1px 1px 1px 0;
  display: block;
  max-width: 16em;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
}

.file-icon {
  align-items: center;
  display: flex;
  height: 1em;
  justify-content: center;
  margin-right: 0.5em;
  width: 1em;
}

.file-icon .fa {
  font-size: 14px;
}
.file {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.file-cta, .file-name {
  /* -moz-appearance: none;
  -webkit-appearance: none; */
  align-items: center;
  border: 1px solid transparent;
  border-radius: 4px;
  box-shadow: none;
  display: inline-flex;
  font-size: 1rem;
  height: 30px;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  border-color: #dbdbdb;
  font-size: 14px;
}
.file-name {
  border-left: none;
}

.wrapper-import > section {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseFormImportExcel.vue